var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"z-index":12,"value":_vm.value}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"84","color":"#50ABA3","width":"15"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }